<template>
  <div
    class="zm-select-dropdown zm-popper"
    :class="[{ 'is-multiple': $parent.multiple,'is-multi-remote': $parent.remote && $parent.multiple }, popperClass]"
    :style="{ minWidth: minWidth, width: widthLimit ? minWidth : 'auto' }"
  >
    <slot></slot>
  </div>
</template>

<script type="text/babel">
  import Popper from '../../utils/vue-popper';

  export default {
    name: 'ZmSelectDropdown',

    componentName: 'ZmSelectDropdown',

    mixins: [Popper],

    props: {
      placement: {
        type: String,
        default: 'bottom-start'
      },

      boundariesPadding: {
        type: Number,
        default: 0
      },

      popperOptions: {
        type: Object
      },

      visibleArrow: {
        type: Boolean,
        default: false
      },

      appendToBody: {
        type: Boolean,
        default: true
      },
      widthLimit: [Boolean, Object]
    },

    data() {
      return {
        minWidth: ''
      };
    },

    computed: {
      popperClass() {
        return this.$parent.popperClass;
      }
    },

    watch: {
      '$parent.inputWidth'() {
        this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
      }
    },

    mounted() {
      this.referenceElm = this.$parent.$el;
      this.$parent.popperElm = this.popperElm = this.$el;
      this.$on('updatePopper', () => {
        if (this.$parent.visible) {
          this.$nextTick(this.updatePopper);
        }
      });
      this.$on('destroyPopper', this.destroyPopper);
    }
  };
</script>

<style lang="scss">
  @import "./select-dropdown";
</style>
